/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

//<custom-head>
import { IconUtils, parseDate } from 'app/utils';
//</custom-head>

export class FileDto {
  public id: string = undefined;
  public fileName: string = undefined;
  public contentType: string = undefined;
  public uploader: string = undefined;
  public createdBy: string = undefined;
  public createdUtc: Date | string;
  public modifiedBy: string = undefined;
  public modifiedUtc: Date | string;

  //<custom-body>
  constructor(source: FileDto) {
    this.id = source.id;
    this.fileName = source.fileName;
    this.contentType = source.contentType;
    this.createdBy = source.createdBy;
    this.createdUtc = parseDate(source.createdUtc);
    this.modifiedBy = source.modifiedBy;
    this.modifiedUtc = parseDate(source.modifiedUtc);
  }

  public get name(): string {
    return this.fileName;
  }

  public get iconClass(): string {
    return IconUtils.contentTypeIconClass(this.contentType);
  }
  //</custom-body>
}
